import requestPasswordReset from 'src/dataLayer/remoteData/babbelAPI/submitPasswordReset';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { useState, useCallback } from 'react';

export default function useSubmitPasswordReset({ captchaResponseToken, password, confirmPassword, passwordResetToken }) {
    const { locale } = useRouteParamsContext();
    const [isLoading, setIsLoading] = useState(false);
    const [errorKey, setErrorKey] = useState(null);
    const [data, setData] = useState(null);

    const makeResetPasswordRequest = useCallback(async (params = {}) => {
        // Use passed parameters or fall back to hook parameters
        const {
            captchaResponseToken: paramCaptchaToken = captchaResponseToken,
            password: paramPassword = password,
            confirmPassword: paramConfirmPassword = confirmPassword,
            passwordResetToken: paramPasswordResetToken = passwordResetToken
        } = params;
        
        if (!paramCaptchaToken || !paramPassword || !paramConfirmPassword || !paramPasswordResetToken) {
            return {
                success: false,
                error: 'Missing required parameters'
            };
        }

        setIsLoading(true);
        setErrorKey(null);
        setData(null);

        try {
            const result = await requestPasswordReset({
                captchaResponseToken: paramCaptchaToken,
                password: paramPassword,
                confirmPassword: paramConfirmPassword,
                passwordResetToken: paramPasswordResetToken,
                locale
            });

            if (result.success) {
                setData(result.data);
                return result;
            } else {
                setErrorKey(result.error);
                return result;
            }

        } catch (error) {
            const errorResult = {
                success: false,
                error: 'Network error occurred',
                networkError: true,
                message: error.message
            };
            setErrorKey(errorResult.error);
            return errorResult;
        } finally {
            setIsLoading(false);
        }
    }, [locale]);

    return {
        resetPasswordRequest: data,
        makeResetPasswordRequest,
        isResetPasswordRequestInProgress: isLoading,
        error: errorKey
    };
};
